import { render, staticRenderFns } from "./VatRateInputs.vue?vue&type=template&id=2975d83b&"
import script from "./VatRateInputs.vue?vue&type=script&lang=ts&"
export * from "./VatRateInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports